(() => {
console.info("%c\uD83D\uDD25CK Started!", 'color: red; font-size: 2rem;');

})();
//# sourceMappingURL=index.js.map
